import { render } from "./ResultPicture.vue?vue&type=template&id=d386125e&scoped=true&ts=true"
import script from "./ResultPicture.vue?vue&type=script&lang=ts"
export * from "./ResultPicture.vue?vue&type=script&lang=ts"

import "./ResultPicture.vue?vue&type=style&index=0&id=d386125e&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d386125e"]])

export default __exports__